import styled, { keyframes } from "styled-components";

export const fade = keyframes`
  0% {
    opacity: 1;
    transform: scale(1) rotate(-360deg);
  }
  50% {
    opacity: 0;
    transform: scale(3);
  }
  100%{
    opacity: 1;
    transform: scale(1);
  }
`;


const Container = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
    position: fixed;
    z-index: 9999;
    background: var(--page-content);
    >img{
        animation: ${fade} 3000ms infinite;
    }
`;

export default Container;

